import { render, staticRenderFns } from "./productDetailCart.vue?vue&type=template&id=1064170c&scoped=true"
import script from "./productDetailCart.vue?vue&type=script&lang=js"
export * from "./productDetailCart.vue?vue&type=script&lang=js"
import style0 from "./productDetailCart.vue?vue&type=style&index=0&id=1064170c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1064170c",
  null
  
)

export default component.exports